var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1753 15.162C11.5462 14.9301 11.7929 14.518 11.7929 14.0484C11.7929 13.3235 11.2053 12.7359 10.4805 12.7359C9.75566 12.7359 9.16806 13.3235 9.16806 14.0484C9.16806 14.518 9.41477 14.9301 9.78568 15.162V17.5225H11.1753V15.162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5104 0.5L1.10533 14.6076C0.405856 15.6568 0.215173 16.9649 0.586012 18.1701C3.59315 27.9433 17.4276 27.9433 20.4348 18.1701C20.8056 16.9649 20.6149 15.6568 19.9154 14.6076L10.5104 0.5ZM3.1276 17.3881L2.91286 16.6902L10.5104 5.29391L18.1079 16.6902L17.8932 17.3881C15.6561 24.6584 5.36462 24.6584 3.1276 17.3881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.bd4b376679c8c5e6939b5ab46219d37a.svg";
export { ForwardRef as ReactComponent };